import React from 'react';
import {
  Grid,
  MenuItem,
  TextField
} from '@material-ui/core';
import { InfoTooltip } from 'components';


const TextFieldSelectorGrid = ({
  name,
  label,
  value,
  onChange,
  InputProps = {},
  classes = '',
  isTooltip = false,
  tooltipTitle,
  items = []
}) => {
  return (
    <Grid container spacing={3} className="ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6} className="flex">
        <TextField
          select
          variant="outlined"
          color="primary"
          fullWidth
          className={classes}
          name={name}
          label={label}
          value={value}
          InputProps={InputProps}
          onChange={(event) => onChange(event.target.value)}
        >
          {items.map((item, index) => (
            <MenuItem key={`${label}-${index}`} value={item}>{item}</MenuItem>
          ))}
        </TextField>
        {isTooltip &&
          <InfoTooltip title={tooltipTitle} />
        }
      </Grid>
    </Grid>
  );
};

export default TextFieldSelectorGrid;
